var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "evaluation-table" }, [
    _c("div", { staticClass: "m-content" }, [
      _c("div", { staticClass: "m-portlet" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "form",
          { staticClass: "m-form m-form--fit m-form--label-align-right" },
          [
            _c("div", { staticClass: "m-portlet__body" }, [
              _c("div", { staticClass: "row form-group m-form__group " }, [
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm m-btn m-btn--custom",
                      class:
                        _vm.defaultDates == 1 ? "btn-primary" : "btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.defaultDates = 1
                        }
                      }
                    },
                    [_vm._v("letzte Woche")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm m-btn m-btn--custom",
                      class:
                        _vm.defaultDates == 2 ? "btn-primary" : "btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.defaultDates = 2
                        }
                      }
                    },
                    [_vm._v("diese Woche")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm m-btn m-btn--custom",
                      class:
                        _vm.defaultDates == 3 ? "btn-primary" : "btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.defaultDates = 3
                        }
                      }
                    },
                    [_vm._v("letzter Monat")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm m-btn m-btn--custom",
                      class:
                        _vm.defaultDates == 4 ? "btn-primary" : "btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.defaultDates = 4
                        }
                      }
                    },
                    [_vm._v("dieser Monat")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm m-btn m-btn--custom",
                      class:
                        _vm.defaultDates == 5 ? "btn-primary" : "btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.defaultDates = 5
                        }
                      }
                    },
                    [_vm._v("letztes Jahr")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm m-btn m-btn--custom",
                      class:
                        _vm.defaultDates == 6 ? "btn-primary" : "btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.defaultDates = 6
                        }
                      }
                    },
                    [_vm._v("dieses Jahr")]
                  )
                ])
              ])
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "m-content" }, [
      _c("div", { staticClass: "row m-row--col-separator-xl" }, [
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#4285F4 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Adwords: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .adwords
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#008373 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Bing: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .bing
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#4267B2 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Facebook: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .facebook
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#F4B400 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Google COM: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .googleCOM
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#F4B400 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Google DE: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .googleDE
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#F4B400 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Google AT: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .googleAT
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#F4B400 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Google CH: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .googleCH
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#AAAAAA !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Yahoo: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .yahoo
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#DDDDDD !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("ecosia: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .ecosia
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#000000 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Keine Angabe: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .emptyString
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#34bfa3 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Sonstiges: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .sonstiges
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#34bfa3 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[1].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Preis zu hoch: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[1].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _c("div", { staticClass: "m-widget14__header" }, [
                    _c("h3", { staticClass: "m-widget14__title" }, [
                      _vm._v(
                        "\n                                        Anfragen nach Kundenklassen ("
                      ),
                      _vm.statistikData.inquiryArr
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.statistikData.inquiryArr.sumOutput
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(")\n                                    ")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "m-widget14__desc" }, [
                      _vm.statistikData.inquiryArr
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.statistikData.inquiryArr.count
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(
                        " Anfragen aufgeteilt in die verschiedenen Kundenklassen\n\t\t\t\t\t\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#34bfa3 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[1]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x A Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[1]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#87decd !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[2]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x B Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[2]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#c3efe6 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[3]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x C Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[3]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#777777 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[4]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x D Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[4]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#999999 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[5]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x E Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[5]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#BBBBBB !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[6]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x F Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[6]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(7),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#34bfa3 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[1].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Preis zu hoch: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[1].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#87decd !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[2].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Wir bieten den Service nicht an: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[2].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#c3efe6 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[3].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Anderen Dienstleister gewählt: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[3].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#777777 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[4].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Keine Rückmeldung: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[4].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#999999 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[5].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Projekt abgesagt: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[5].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#BBBBBB !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[6].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Arschlochkunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[6].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#000000 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[7].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Sonstiges: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[7].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _c("div", { staticClass: "m-widget14__header" }, [
                    _c("h3", { staticClass: "m-widget14__title" }, [
                      _vm._v(
                        "\n                                        Timetracks (" +
                          _vm._s(_vm.statistikData.hoursTrackt) +
                          ")\n                                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "m-widget14__desc" }, [
                      _vm._v(
                        "\n                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.\n\t\t\t\t\t\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#000000 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Franzi: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[3].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#34bfa3 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Daniela: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[659].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#666666 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Sarah: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[341].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#36a3f7 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Steffen: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[652].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#999999 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Lena: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[529].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#716aca !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Lara: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[637].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#716aca !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Jessy: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[1525]
                                          .hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(10),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#000000 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Franzi: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[3]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[3].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#34bfa3 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Daniela: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[659]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[659].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#666666 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Sarah: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[341]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[341].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#36a3f7 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Steffen: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[652]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[652].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#999999 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Lena: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[529]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[529].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#716aca !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Lara: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[637]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[637].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _c("div", { staticClass: "m-widget14__header" }, [
                    _c("h3", { staticClass: "m-widget14__title" }, [
                      _vm._v(
                        "\n                                        Arbeitsstunden "
                      ),
                      _vm.statistikData.workload
                        ? _c("span", [
                            _vm._v("(Auslastung: "),
                            _vm.statistikData.workload < 70
                              ? _c("span", { staticClass: "m--font-danger" }, [
                                  _vm._v(
                                    _vm._s(_vm.statistikData.workload) + "%"
                                  )
                                ])
                              : _c("span", { staticClass: "m--font-success" }, [
                                  _vm._v(
                                    _vm._s(_vm.statistikData.workload) + "%"
                                  )
                                ]),
                            _vm._v(")")
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "m-widget14__desc" }, [
                      _vm._v(
                        "\n                                        Wieviele Arbeitsstunden stehen zur Verfügung. Gerechnet wird mit 3,5 aktiven Arbeitern.\n\t\t\t\t\t\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(11)
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(12),
        _vm._v(" "),
        _vm._m(13),
        _vm._v(" "),
        _vm.statistikData.doneArr
          ? _c("div", { staticClass: "col-xl-6 d-none" }, [
              _c("div", { staticClass: "m-portlet" }, [
                _c(
                  "div",
                  {
                    staticClass: "m-portlet__body m-portlet__body--no-padding"
                  },
                  [
                    _c("div", { staticClass: "m-widget14" }, [
                      _vm._m(14),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-5" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("0 Uhr - 6 Uhr")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.statistikData.doneArr.time["0-6"].sum
                                    .toFixed(2)
                                    .replace(".", ",")
                                ) +
                                  "€ (" +
                                  _vm._s(
                                    _vm.statistikData.doneArr.time["0-6"].count
                                  ) +
                                  " Stk.)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("6 Uhr - 12 Uhr")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.statistikData.doneArr.time["6-12"].sum
                                    .toFixed(2)
                                    .replace(".", ",")
                                ) +
                                  "€ (" +
                                  _vm._s(
                                    _vm.statistikData.doneArr.time["6-12"].count
                                  ) +
                                  " Stk.)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("12 Uhr - 18 Uhr")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.statistikData.doneArr.time["12-18"].sum
                                    .toFixed(2)
                                    .replace(".", ",")
                                ) +
                                  "€ (" +
                                  _vm._s(
                                    _vm.statistikData.doneArr.time["12-18"]
                                      .count
                                  ) +
                                  " Stk.)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("18 Uhr - 20 Uhr")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.statistikData.doneArr.time["18-20"].sum
                                    .toFixed(2)
                                    .replace(".", ",")
                                ) +
                                  "€ (" +
                                  _vm._s(
                                    _vm.statistikData.doneArr.time["18-20"]
                                      .count
                                  ) +
                                  " Stk.)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("20 Uhr - 24 Uhr")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.statistikData.doneArr.time["20-0"].sum
                                    .toFixed(2)
                                    .replace(".", ",")
                                ) +
                                  "€ (" +
                                  _vm._s(
                                    _vm.statistikData.doneArr.time["20-0"].count
                                  ) +
                                  " Stk.)"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-5 offset-2" }, [
                          _vm.statistikData.doneArr.day[1]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Montag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[1].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[1].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[2]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Dienstag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[2].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[2].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[3]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Mittwoch")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[3].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[3].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[4]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Donnerstag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[4].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[4].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[5]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Freitag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[5].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[5].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[6]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Samstag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[6].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[6].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[7]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Sonntag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[7].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[7].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e()
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.statistikData.doneArr && _vm.statistikData.doneArr.projectArr
        ? _c(
            "div",
            { staticClass: "row m-row--col-separator-xl" },
            _vm._l(_vm.statistikData.doneArr.projectArr, function(project) {
              return _c("project-stats", {
                key: project.id,
                staticClass: "col-xl-4",
                attrs: { project: project }
              })
            }),
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "m-content" }, [
      _c("div", { staticClass: "row m-row--col-separator-xl" }, [
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _vm._m(15),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(16),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#4285F4 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.saleArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Adwords: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.refferer
                                          .adwords
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _vm._m(17),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(18),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#34bfa3 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[1].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Preis zu hoch: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[1].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _c("div", { staticClass: "m-widget14__header" }, [
                    _c("h3", { staticClass: "m-widget14__title" }, [
                      _vm._v(
                        "\n                                        Anfragen nach Kundenklassen ("
                      ),
                      _vm.statistikData.inquiryArr
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.statistikData.inquiryArr.sumOutput
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(")\n                                    ")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "m-widget14__desc" }, [
                      _vm.statistikData.inquiryArr
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.statistikData.inquiryArr.count
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(
                        " Anfragen aufgeteilt in die verschiedenen Kundenklassen\n\t\t\t\t\t\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(19),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#34bfa3 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[1]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x A Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[1]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#87decd !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[2]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x B Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[2]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#c3efe6 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[3]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x C Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[3]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#777777 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[4]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x D Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[4]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#999999 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[5]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x E Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[5]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#BBBBBB !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[6]
                                          .count
                                      )
                                    }
                                  }),
                                  _vm._v("x F Kunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryArr.classArr[6]
                                          .sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _vm._m(20),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(21),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#34bfa3 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[1].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Preis zu hoch: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[1].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#87decd !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[2].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Wir bieten den Service nicht an: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[2].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#c3efe6 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[3].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Anderen Dienstleister gewählt: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[3].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#777777 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[4].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Keine Rückmeldung: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[4].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#999999 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[5].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Projekt abgesagt: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[5].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#BBBBBB !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[6].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Arschlochkunde: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[6].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#000000 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.inquiryNegativeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[7].count
                                      )
                                    }
                                  }),
                                  _vm._v("x Sonstiges: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.inquiryNegativeArr
                                          .reasons[7].sumOutput
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _c("div", { staticClass: "m-widget14__header" }, [
                    _c("h3", { staticClass: "m-widget14__title" }, [
                      _vm._v(
                        "\n                                        Timetracks (" +
                          _vm._s(_vm.statistikData.hoursTrackt) +
                          ")\n                                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "m-widget14__desc" }, [
                      _vm._v(
                        "\n                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.\n\t\t\t\t\t\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(22),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#000000 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Franzi: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[3].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#34bfa3 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Daniela: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[659].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#666666 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Sarah: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[341].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#36a3f7 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Steffen: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[652].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#999999 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Lena: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[529].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#716aca !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Lara: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[637].hours
                                      )
                                    }
                                  }),
                                  _vm._v(" HH:MM")
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _vm._m(23),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(24),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "m-widget14__legends" }, [
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#000000 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Franzi: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[3]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[3].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#34bfa3 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Daniela: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[659]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[659].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#666666 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Sarah: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[341]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[341].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#36a3f7 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Steffen: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[652]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[652].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#999999 !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Lena: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[529]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[529].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget14__legend" }, [
                          _c("span", {
                            staticClass:
                              "m-widget14__legend-bullet m--bg-accent",
                            staticStyle: {
                              "background-color": "#716aca !important"
                            }
                          }),
                          _vm._v(" "),
                          _vm.statistikData.employeeArr
                            ? _c(
                                "span",
                                { staticClass: "m-widget14__legend-text" },
                                [
                                  _vm._v("Lara: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[637]
                                          .sumFormat
                                      )
                                    }
                                  }),
                                  _vm._v(" ("),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.statistikData.employeeArr[637].count
                                      )
                                    }
                                  }),
                                  _vm._v(" Projekte)")
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-6" }, [
          _c("div", { staticClass: "m-portlet" }, [
            _c(
              "div",
              { staticClass: "m-portlet__body m-portlet__body--no-padding" },
              [
                _c("div", { staticClass: "m-widget14" }, [
                  _c("div", { staticClass: "m-widget14__header" }, [
                    _c("h3", { staticClass: "m-widget14__title" }, [
                      _vm._v(
                        "\n                                        Arbeitsstunden "
                      ),
                      _vm.statistikData.workload
                        ? _c("span", [
                            _vm._v("(Auslastung: "),
                            _vm.statistikData.workload < 70
                              ? _c("span", { staticClass: "m--font-danger" }, [
                                  _vm._v(
                                    _vm._s(_vm.statistikData.workload) + "%"
                                  )
                                ])
                              : _c("span", { staticClass: "m--font-success" }, [
                                  _vm._v(
                                    _vm._s(_vm.statistikData.workload) + "%"
                                  )
                                ]),
                            _vm._v(")")
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "m-widget14__desc" }, [
                      _vm._v(
                        "\n                                        Wieviele Arbeitsstunden stehen zur Verfügung. Gerechnet wird mit 3,5 aktiven Arbeitern.\n\t\t\t\t\t\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(25)
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(26),
        _vm._v(" "),
        _vm._m(27),
        _vm._v(" "),
        _vm.statistikData.doneArr
          ? _c("div", { staticClass: "col-xl-6 d-none" }, [
              _c("div", { staticClass: "m-portlet" }, [
                _c(
                  "div",
                  {
                    staticClass: "m-portlet__body m-portlet__body--no-padding"
                  },
                  [
                    _c("div", { staticClass: "m-widget14" }, [
                      _vm._m(28),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-5" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("0 Uhr - 6 Uhr")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.statistikData.doneArr.time["0-6"].sum
                                    .toFixed(2)
                                    .replace(".", ",")
                                ) +
                                  "€ (" +
                                  _vm._s(
                                    _vm.statistikData.doneArr.time["0-6"].count
                                  ) +
                                  " Stk.)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("6 Uhr - 12 Uhr")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.statistikData.doneArr.time["6-12"].sum
                                    .toFixed(2)
                                    .replace(".", ",")
                                ) +
                                  "€ (" +
                                  _vm._s(
                                    _vm.statistikData.doneArr.time["6-12"].count
                                  ) +
                                  " Stk.)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("12 Uhr - 18 Uhr")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.statistikData.doneArr.time["12-18"].sum
                                    .toFixed(2)
                                    .replace(".", ",")
                                ) +
                                  "€ (" +
                                  _vm._s(
                                    _vm.statistikData.doneArr.time["12-18"]
                                      .count
                                  ) +
                                  " Stk.)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("18 Uhr - 20 Uhr")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.statistikData.doneArr.time["18-20"].sum
                                    .toFixed(2)
                                    .replace(".", ",")
                                ) +
                                  "€ (" +
                                  _vm._s(
                                    _vm.statistikData.doneArr.time["18-20"]
                                      .count
                                  ) +
                                  " Stk.)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v("20 Uhr - 24 Uhr")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.statistikData.doneArr.time["20-0"].sum
                                    .toFixed(2)
                                    .replace(".", ",")
                                ) +
                                  "€ (" +
                                  _vm._s(
                                    _vm.statistikData.doneArr.time["20-0"].count
                                  ) +
                                  " Stk.)"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-5 offset-2" }, [
                          _vm.statistikData.doneArr.day[1]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Montag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[1].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[1].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[2]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Dienstag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[2].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[2].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[3]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Mittwoch")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[3].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[3].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[4]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Donnerstag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[4].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[4].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[5]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Freitag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[5].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[5].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[6]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Samstag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[6].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[6].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statistikData.doneArr.day[7]
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v("Sonntag")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.statistikData.doneArr.day[7].sum
                                        .toFixed(2)
                                        .replace(".", ",")
                                    ) +
                                      "€ (" +
                                      _vm._s(
                                        _vm.statistikData.doneArr.day[7].count
                                      ) +
                                      " Stk.)"
                                  )
                                ])
                              ])
                            : _vm._e()
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.statistikData.doneArr && _vm.statistikData.doneArr.projectArr
        ? _c(
            "div",
            { staticClass: "row m-row--col-separator-xl" },
            _vm._l(_vm.statistikData.doneArr.projectArr, function(project) {
              return _c("project-stats", {
                key: project.id,
                staticClass: "col-xl-4",
                attrs: { project: project }
              })
            }),
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v(
              "\n                                Filter\n                            "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget14__header" }, [
      _c("h3", { staticClass: "m-widget14__title" }, [
        _vm._v(
          "\n                                        Anfragen Herkunft\n                                    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "m-widget14__desc" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_inquiry_inquiry_refferer" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget14__header" }, [
      _c("h3", { staticClass: "m-widget14__title" }, [
        _vm._v(
          "\n                                        Projekte abgeschlossen Herkunft\n                                    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "m-widget14__desc" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_inquiry_project_refferer" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_inquiry_class_chart" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget14__header" }, [
      _c("h3", { staticClass: "m-widget14__title" }, [
        _vm._v(
          "\n                                        Absagen für Anfragen\n                                    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "m-widget14__desc" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_inquiry_absagen_chart" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_timetrack_chart" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget14__header" }, [
      _c("h3", { staticClass: "m-widget14__title" }, [
        _vm._v(
          "\n                                        Umsatz Fotografen ()\n                                    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "m-widget14__desc" }, [
        _vm._v(
          "\n                                        Zusammengefasst in Geld, von fotografierten Projekten in dem Zeitraum.\n\t\t\t\t\t\t\t\t\t"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_employee_chart" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row align-items-center" }, [
      _c("div", { staticClass: "col" }, [
        _c("p", [_vm._v("Auslastung")]),
        _vm._v(" "),
        _c("div", {
          staticStyle: { height: "275px" },
          attrs: { id: "m_morris_2" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xl-6" }, [
      _c("div", { staticClass: "m-portlet" }, [
        _c(
          "div",
          { staticClass: "m-portlet__body m-portlet__body--no-padding" },
          [
            _c("div", { staticClass: "m-widget14" }, [
              _c("div", { staticClass: "m-widget14__header" }, [
                _c("h3", { staticClass: "m-widget14__title" }, [
                  _vm._v(
                    "\n                                        Summen\n                                    "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "m-widget14__desc" }, [
                  _vm._v(
                    "\n                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.\n\t\t\t\t\t\t\t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c("p", [
                    _vm._v(
                      "Wieviele Projekte haben wir in diesem Monat bekommen"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { height: "275px" },
                    attrs: { id: "m_morris_1" }
                  })
                ])
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xl-6" }, [
      _c("div", { staticClass: "m-portlet" }, [
        _c(
          "div",
          { staticClass: "m-portlet__body m-portlet__body--no-padding" },
          [
            _c("div", { staticClass: "m-widget14" }, [
              _c("div", { staticClass: "m-widget14__header" }, [
                _c("h3", { staticClass: "m-widget14__title" }, [
                  _vm._v(
                    "\n                                        Projekte nach Kategorie\n                                    "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "m-widget14__desc" }, [
                  _vm._v(
                    "\n                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.\n\t\t\t\t\t\t\t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", {
                    staticClass: "m-widget14__chart1",
                    staticStyle: { height: "300px" },
                    attrs: { id: "m_category_chart" }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "m-widget14__legends" })
                ])
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget14__header" }, [
      _c("h3", { staticClass: "m-widget14__title" }, [
        _vm._v(
          "\n                                        Abgeschlossene Projekte -> Wann generiert?\n                                    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "m-widget14__desc" }, [
        _vm._v(
          "\n                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.\n\t\t\t\t\t\t\t\t\t"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget14__header" }, [
      _c("h3", { staticClass: "m-widget14__title" }, [
        _vm._v(
          "\n                                        Neukunden / Stammkunden\n                                    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "m-widget14__desc" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_inquiry_inquiry_neu-stamm" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget14__header" }, [
      _c("h3", { staticClass: "m-widget14__title" }, [
        _vm._v(
          "\n                                        Projekte abgeschlossen Herkunft\n                                    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "m-widget14__desc" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_inquiry_project_refferer" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_inquiry_class_chart" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget14__header" }, [
      _c("h3", { staticClass: "m-widget14__title" }, [
        _vm._v(
          "\n                                        Absagen für Anfragen\n                                    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "m-widget14__desc" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_inquiry_absagen_chart" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_timetrack_chart" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget14__header" }, [
      _c("h3", { staticClass: "m-widget14__title" }, [
        _vm._v(
          "\n                                        Umsatz Fotografen ()\n                                    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "m-widget14__desc" }, [
        _vm._v(
          "\n                                        Zusammengefasst in Geld, von fotografierten Projekten in dem Zeitraum.\n\t\t\t\t\t\t\t\t\t"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", {
        staticClass: "m-widget14__chart1",
        staticStyle: { height: "300px" },
        attrs: { id: "m_employee_chart" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row align-items-center" }, [
      _c("div", { staticClass: "col" }, [
        _c("p", [_vm._v("Auslastung")]),
        _vm._v(" "),
        _c("div", {
          staticStyle: { height: "275px" },
          attrs: { id: "m_morris_2" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xl-6" }, [
      _c("div", { staticClass: "m-portlet" }, [
        _c(
          "div",
          { staticClass: "m-portlet__body m-portlet__body--no-padding" },
          [
            _c("div", { staticClass: "m-widget14" }, [
              _c("div", { staticClass: "m-widget14__header" }, [
                _c("h3", { staticClass: "m-widget14__title" }, [
                  _vm._v(
                    "\n                                        Summen\n                                    "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "m-widget14__desc" }, [
                  _vm._v(
                    "\n                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.\n\t\t\t\t\t\t\t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c("p", [
                    _vm._v(
                      "Wieviele Projekte haben wir in diesem Monat bekommen"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { height: "275px" },
                    attrs: { id: "m_morris_1" }
                  })
                ])
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xl-6" }, [
      _c("div", { staticClass: "m-portlet" }, [
        _c(
          "div",
          { staticClass: "m-portlet__body m-portlet__body--no-padding" },
          [
            _c("div", { staticClass: "m-widget14" }, [
              _c("div", { staticClass: "m-widget14__header" }, [
                _c("h3", { staticClass: "m-widget14__title" }, [
                  _vm._v(
                    "\n                                        Projekte nach Kategorie\n                                    "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "m-widget14__desc" }, [
                  _vm._v(
                    "\n                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.\n\t\t\t\t\t\t\t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", {
                    staticClass: "m-widget14__chart1",
                    staticStyle: { height: "300px" },
                    attrs: { id: "m_category_chart" }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "m-widget14__legends" })
                ])
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget14__header" }, [
      _c("h3", { staticClass: "m-widget14__title" }, [
        _vm._v(
          "\n                                        Abgeschlossene Projekte -> Wann generiert?\n                                    "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "m-widget14__desc" }, [
        _vm._v(
          "\n                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.\n\t\t\t\t\t\t\t\t\t"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }